import React, { useEffect, useState } from "react";
import {
  FiTwitter,
  FiLinkedin,
  FiFacebook,
  FiMail,
  FiMapPin,
  FiPhone,
  FiInstagram,
} from "react-icons/fi";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  GetRelationshipOfficerDetails,
  GetTeams,
} from "../../redux/utils/utilsSlice";
import { FaUserCircle, FaHeadset, FaWhatsapp } from "react-icons/fa";
import LoadingSpinner from "../../components/LoadingSpinner";
import PageName from "../../components/PageName";
import LiveChat from "../livechat/live-chat";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const Support = () => {
  const dispatch = useAppDispatch();
  const {
    relationshipOfficerDetails: accountManager,
    teamDetails,
    isLoading,
  } = useAppSelector((state) => state?.utils);

  // State to track whether the live chat window is open
  const [isLiveChatOpen, setIsLiveChatOpen] = useState(false);

  // Define an array of locations with names, addresses, and latitude/longitude
  const locations = [
    {
      name: "Location 1",
      address: "312 Ikorodu-Ososun Rd, Ikorodu 104101, Lagos",
      latitude: 6.6175, // Replace with actual latitude
      longitude: 3.5242, // Replace with actual longitude
    },
    {
      name: "Location 2",
      address: "Your second location address goes here",
      latitude: 0.0, // Replace with actual latitude
      longitude: 0.0, // Replace with actual longitude
    },
    {
      name: "Location 3",
      address: "Your third location address goes here",
      latitude: 0.0, // Replace with actual latitude
      longitude: 0.0, // Replace with actual longitude
    },
    {
      name: "Location 4",
      address: "Your fourth location address goes here",
      latitude: 0.0, // Replace with actual latitude
      longitude: 0.0, // Replace with actual longitude
    },
    {
      name: "Location 5",
      address: "Your fifth location address goes here",
      latitude: 0.0, // Replace with actual latitude
      longitude: 0.0, // Replace with actual longitude
    },
  ];

  // State to track the selected location
  const [selectedLocation, setSelectedLocation] = useState(null);

  useEffect(() => {
    dispatch(GetRelationshipOfficerDetails());
  }, []);

  useEffect(() => {
    dispatch(GetTeams());
  }, []);

  const toggleLiveChat = () => {
    setIsLiveChatOpen((prev) => !prev); // Toggle the state between open and closed
  };

  const handleLocationChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedLocation(selectedValue);

    // Find the selected location by its address and get its latitude and longitude
    const selectedLocationData = teamDetails.find(
      (location) => location.address === selectedValue
    );
    if (selectedLocationData) {
      //   const { latitude, longitude } = selectedLocationData;
      // Set the latitude and longitude in state
      setMapCoordinates({ latitude: 6.5244, longitude: 3.3792 });
    }
  };

  // State to store latitude and longitude for Google Maps
  const [mapCoordinates, setMapCoordinates] = useState({
    latitude: 0,
    longitude: 0,
  });

  return (
    <TimeOutActivityLayout>
    <div className="support-page">
      <PageName pageName={"Support"} />
      <div className="account-manager acm">
        <div className="acm__head">My Account Manager</div>
        {isLoading ? (
          <LoadingSpinner size={"md"} />
        ) : (
          <div className="acm__body">
            <div className="acm__img">
              <FaUserCircle className="img" />
            </div>
            <div className="acm__name">{accountManager.name}</div>
            <div className="acm__phone">
              <a href={`tel:${accountManager.phoneNumber}`}>
                {accountManager.phoneNumber}
              </a>
            </div>
            <div className="acm__email">
              <a href={`mailto:${accountManager.email}`}>
                {accountManager.email}
              </a>
            </div>
          </div>
        )}
      </div>

      <div className="acm__head">Contact Information</div>
      <div className="cards">
        <div className="support-card card">
          <div className="card__head">
            <div className="card__head--icon">
              <FiMapPin className="img" />
            </div>
            <div className="card__head--">Locate us</div>
          </div>
          <div className="card__text">
            {/* Render a dropdown with location options */}
            <select
              onChange={handleLocationChange}
              value={selectedLocation || ""}
            >
              <option value="" disabled>
                Select a location
              </option>
              {teamDetails.map((location, index) => (
                <option key={index} value={location.address}>
                  {location.txtName}
                </option>
              ))}
            </select>
            {/* Display the address of the selected location */}
            {selectedLocation && (
              <div className="selected-location-address">
                Address: {selectedLocation}
              </div>
            )}
          </div>
        </div>
        {/* ... Other Contact Information Cards ... */}

        <div className="support-card card">
          <div className="card__head">
            <div className="card__head--icon">
              <FiPhone className="img" />
            </div>
            <div className="card__head--">Call Us</div>
          </div>
          <div className="card__text">
            {/* <a href="tel:014482780">01-4482780</a> */}
            <br />
            <a href="tel:07000-2255-6572732">07000-2255-6572732</a><br/>
                   
            <br />
            {/* <a href="tel:09139338285">09139338285</a> */}
          </div>
        </div>
        <div className="support-card card">
          <div className="card__head">
            <div className="card__head--icon">
              <FiMail className="img" />
            </div>
            <div className="card__head--">Email Us</div>
          </div>
          <div className="card__text">
            <a href="mailto:csu@nlpcpfa.com">
              csu@nlpcpfa.com
            </a>
          </div>
        </div>
      </div>

      {/* Display Google Map component */}
      <div className="google-map-container">
        {mapCoordinates.latitude !== 0 && mapCoordinates.longitude !== 0 && (
          <iframe
            src={`https://maps.google.com/maps?q=${mapCoordinates.latitude},${mapCoordinates.longitude}&z=15&output=embed`}
            width="100%"
            height="450"
            frameBorder="0"
            aria-hidden="false"
            title="Selected Location"
          ></iframe>
        )}
      </div>

      <div className="acm__head mt-6">Find us on social media</div>
      <div className="social-media flex justify-center pb-10 pb-32 flex-wrap">
        <a href="https://www.nlpcpfa.com/" target="_blank" className="mx-3 my-2 text-sm">
          <div className="my-2 text-3xl sm:text-4xl text-primary flex justify-center">
            <FaHeadset />
          </div>
          Live Chat
        </a>
        <a
          href="https://twitter.com/nlpcpfa"
          target="_blank"
          className="mx-3 my-2 text-sm"
        >
          <div className="my-2 text-3xl sm:text-4xl text-primary flex justify-center">
            <FiTwitter />
          </div>
          Twitter
        </a>
        <a
          href="https://www.facebook.com/nlpcpfa"
          target="_blank"
          className="mx-3 my-2 text-sm"
        >
          <div className="my-2 text-3xl sm:text-4xl text-primary flex justify-center">
            <FiFacebook />
          </div>
          Facebook
        </a>
        <a
          href="https://www.linkedin.com/company/3255322"
          target="_blank"
          className="mx-3 my-2 text-sm"
        >
          <div className="my-2 text-3xl sm:text-4xl text-primary flex justify-center">
            <FiLinkedin />
          </div>
          LinkedIn
        </a>
        <a
          href="https://www.instagram.com/nlpcpfa/"
          target="_blank"
          className="mx-3 my-2 text-sm"
        >
          <div className="my-2 text-3xl sm:text-4xl text-primary flex justify-center">
            <FiInstagram />
          </div>
          Instagram
        </a>
        <a
          href="https://wa.link/nfbmud"
          target="_blank"
          className="mx-3 my-2 text-sm"
        >
          <div className="my-2 text-3xl sm:text-4xl text-primary flex justify-center">
            <FaWhatsapp />
          </div>
          Whatsapp
        </a>
      </div>

      {isLiveChatOpen && <LiveChat />}
    </div>
    </TimeOutActivityLayout>
  );
};

export default Support;
